import { render, staticRenderFns } from "./ApplianceTypesList.vue?vue&type=template&id=031c2568"
import script from "./ApplianceTypesList.vue?vue&type=script&lang=js"
export * from "./ApplianceTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports